/**
 * Coach-side client management writes through the global apiClient. Non-throwing.
 */

import { api, type ApiResponse } from '@/lib/apiClient';

export function setClientArchived(clientId: string, archive: boolean): Promise<ApiResponse> {
  return api.patch('/api/clients/archive', { clientId, archive });
}

/**
 * Email a client their signup link. Failure bodies may carry `code: 'CLIENT_LIMIT_REACHED'` with
 * `limit` / `current` (read from `body`); success may carry `existingInvite` (24h dedupe — no email
 * was sent).
 */
export function sendInviteEmail(body: {
  email: string;
  inviteId: string;
  clientName: string;
  signupUrl: string;
  coachName: string;
}): Promise<ApiResponse & { existingInvite?: boolean; inviteId?: string }> {
  return api.post('/api/send-invite-email', body);
}
